module.exports = __webpack_public_path__ + "assets/img/logo_yellow.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_yellow.png
// module id = 1964
// module chunks = 0